module.exports = "<footer>\r\n    <p class=\"text-xs-center\">&copy; Copyright 2019. All rights reserved.</p>\r\n</footer>"